const constants = {
  DEFAULT_WIDTH: 1000,
  DEFAULT_EMBED_WIDTH: 1000,
  DEFAULT_EMBED_HEIGHT: 1000 * 360 / 640
}

export default constants; 
